export default __webpack_public_path__ + "static/media/upload.1b114afd.svg";